// extracted by mini-css-extract-plugin
export var pillWrapper = "_n0-0";
export var showOverflow = "_n0-1";